import React from 'react'

export type SectionPreHeaderProps = {
  icon?: React.ReactNode
  children: React.ReactNode
  className?: string
}

export function SectionPreHeader({ icon, children, className = '' }: SectionPreHeaderProps) {
  return (
    <div
      className={`flex items-center gap-2 text-gray-500 uppercase text-sm font-medium tracking-wide ${className}`.trim()}
    >
      {icon}
      <span>{children}</span>
    </div>
  )
}
